export enum CreateQuizType {
  MASTERY = 'MASTERY',
  CUSTOM = 'CUSTOM',
  NGN_CASE_STUDY = 'NGN_CASE_STUDY',
}

export interface CreateQuizSelection {
  // Sherpath and Book-Based Standalone students pick a question bank; EAQ for NCLEX students have a fixed one
  isQuestionBankRequired: boolean;
  questionBankIsbn?: string;
  quizType?: CreateQuizType;
  topicIds: string[];
  masteryGoal?: string;
  questionCount?: number;
}

export interface CreateQuizStep {
  id: string;
  title: string;
  render: () => React.ReactNode;
}
